import moment, { Moment } from 'moment';
import React, { FC } from 'react';

type Props = {
  timestamp: Moment;
};
export const isSameCentury = (date: Moment) =>
  Math.floor(date.get('year') / 100) === Math.floor(moment().get('year') / 100);
export const isSameYear = (date: Moment) => moment().isSame(date, 'year');
export const humaiseYear = (date: Moment) =>
  isSameYear(date)
    ? ''
    : isSameCentury(date)
    ? date.format('YY')
    : date.format('YYYY');

export const humanise = (date: Moment): string =>
  date.format(
    `DD MMM${
      !moment().isSame(date, 'year')
        ? isSameCentury(date)
          ? ' YY'
          : ' YYYY'
        : ''
    }`,
  );

export const HumanisedDate: FC<Props> = ({ timestamp }) => (
  <>{humanise(timestamp)}</>
);

export const humaniseWithDay = (date: Moment): string =>
  date.format(
    `ddd DD MMM${
      !moment().isSame(date, 'year')
        ? isSameCentury(date)
          ? ' YY'
          : ' YYYY'
        : ''
    }`,
  );
